import request from '@/utils/request'

// 列表
export function listPage(data) {
    return request({
        url: 'admin/data/specialWork/list',
        method: 'post',
        data
    })
}
// 列表
export function specialWorkSum(data) {
    return request({
        url: 'admin/data/specialWork/specialWorkSum',
        method: 'post',
        data
    })
}

//  详情
export function info(id) {
    return request({
        url: 'admin/data/specialWork/specialWorkDeclareInfo/' + id,
        method: 'get'
    })
}

//  特殊作业人员
export function specialWorkPersonInfo(id) {
    return request({
        url: 'admin/data/specialWork/specialWorkPersonInfo/' + id,
        method: 'get'
    })
}

// 新增/编辑
export function saveOrUpdate(data) {
    return request({
        url: 'admin/data/specialWork/saveOrUpdate',
        method: 'post',
        data
    })
}
// 工单
export function secondaryFireOrder(data) {
    return request({
        url: 'admin/data/specialWork/secondaryFireOrder/'+data,
        method: 'get',
    })
}

// 删除
export function deleteSpecialWorkDeclare(id) {
    return request({
        url: 'admin/data/specialWork/deleteSpecialWorkDeclare/' + id,
        method: 'post'
    })
}

// 生成工单
export function generateWorkOrder(data) {
    return request({
        url: 'admin/data/specialWork/generateWorkOrder',
        method: 'post',
        data
    })
}

//  根据企业id获取坐标
export function companyPosition(id) {
    return request({
        url: 'admin/data/specialWork/companyPosition/' + id,
        method: 'get'
    })
}

export function analysisData(data) {
    return request({
        url: 'admin/data/specialWork/analysisData',
        method: 'post',
        data
    })
}